import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import API from "../services/api";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post("/api/auth/login", {
        email: email.trim(),
        password
      });

      localStorage.setItem("token", res.data.token);
      window.location.href = "/todo";
    } catch (err) {
      alert(err.response?.data?.message || "Login failed");
    }
  };

return (
  <div className="auth-container">
    <form className="auth-card" onSubmit={handleLogin}>
      <h2>Login</h2>

      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />

      <button type="submit">Login</button>

      <p>
        New user? <Link to="/register">Register</Link>
      </p>
    </form>
  </div>
);

}

export default Login;
